module.exports = __webpack_public_path__ + "img/crowdfunding.31a14543.svg";